import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0061ab01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = {
  class: "ant-row",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ant-upload-drag-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ui-nova-arquivo" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text ui-nova-arquivo-descricao" }, "Formatos aceitos: Imagens, Videos, PDFs e documentos.", -1))
const _hoisted_11 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ui-arquivo" }
const _hoisted_14 = {
  key: 0,
  class: "ui-thumb"
}
const _hoisted_15 = { class: "ui-arquivo-info ui-full" }
const _hoisted_16 = { class: "ui-arquivo-nome" }
const _hoisted_17 = { class: "ui-arquivo-tamanho" }
const _hoisted_18 = { class: "ui-move ui-ordenar-arquivo" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
              class: "ant-upload ant-upload-drag",
              onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("input", {
                  id: "selecionarArquivo",
                  type: "file",
                  accept: ".png, .jpg, .jpeg, .webp",
                  multiple: "",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarArquivos && _ctx.enviarArquivos(...args))),
                  style: {"display":"none"}
                }, null, 32),
                _createElementVNode("div", {
                  class: "ant-upload-drag-container",
                  onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dropArquivo && _ctx.dropArquivo(...args)))
                }, [
                  ((_ctx.state.enviandoArquivos || _ctx.state.excluindoArquivos))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, [
                          _createVNode(_component_a_spin, { size: "large" })
                        ]),
                        _hoisted_7
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_icone, {
                            style: {"font-size":"18px"},
                            nome: "upload-nuvem"
                          }),
                          _createTextVNode(" Selecione ou arraste e solte seus arquivos aqui")
                        ]),
                        _hoisted_10
                      ]))
                ], 32)
              ])
            ], 32)
          ])
        ]),
        (_ctx.computedArquivos.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_image_preview_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.computedArquivos,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedArquivos) = $event)),
                      "item-key": "arquivo",
                      handle: ".ui-move",
                      class: _normalizeClass(_ctx.computedArquivos.length > 9 ? 'ui-daj-center ui-arquivos' : 'ui-arquivos')
                    }, {
                      item: _withCtx(({ element }) => [
                        _createElementVNode("div", _hoisted_13, [
                          (_ctx.isImagem(element))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(_component_a_image, {
                                  style: {"min-height":"100px"},
                                  width: 100,
                                  src: element.link,
                                  alt: element.nome
                                }, null, 8, ["src", "alt"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(element.nome), 1),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(element.tamanho), 1),
                            _createVNode(_component_a_input, {
                              value: element.legenda,
                              "onUpdate:value": ($event: any) => ((element.legenda) = $event),
                              size: "small",
                              class: "ui-arquivo-legenda ui-full",
                              placeholder: "Legenda (opcional)",
                              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.change())),
                              "max-length": 200
                            }, null, 8, ["value", "onUpdate:value"]),
                            _createVNode(_component_a_tooltip, {
                              title: "Ordenar",
                              placement: "bottom"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_18, [
                                  _createVNode(_component_icone, { nome: "draggable" })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_tooltip, {
                              title: "Remover",
                              color: "red",
                              placement: "bottom"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  title: "Remover",
                                  onClick: ($event: any) => (_ctx.confirmaExclusao(element)),
                                  class: "ui-remover-arquivo"
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_19)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}